module.exports = __webpack_public_path__ + "img/CRT_Bow 002.7660ac3c.png";